import { lazy } from "react";
import Loadable from "app/components/Loadable";

const UserSetup = Loadable(lazy(() => import("./UserSetup")));

const usersetupRoute = [{ path: "/user-setup", element: <UserSetup /> }];
export default usersetupRoute;
